import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { Shared } from './shared.service';
import { ControlCanActivate } from './control-can-activate.guard';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from "angularfire2/auth";
import { environment } from '../environments/environment';

import { Ng2ImgToolsModule } from 'ng2-img-tools';

import { AppComponent } from './app.component';
import { ControlComponent } from './control/control.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { MenuItemContainerComponent } from './menu-item-container/menu-item-container.component';
import { MenuComponent } from './menu/menu.component';
import { ProductItemComponent } from './product-item/product-item.component';
import { ProductsComponent } from './products/products.component';
import { SettingsComponent } from './settings/settings.component';
import { LoginComponent } from './login/login.component';
import { ProductFormComponent } from './product-form/product-form.component';
import { ProductPipe } from './product-pipe.pipe';
import { ProductSortPipe } from './product-sort.pipe';
import { LabelledProductsComponent } from './labelled-products/labelled-products.component';
import { DetailsComponent } from './details/details.component';
import { MenuSettingsComponent } from './menu-settings/menu-settings.component';
import { AccountComponent } from './account/account.component';
import { SupportComponent } from './support/support.component';
import { LocationComponent } from './location/location.component';
import { BoardlinkComponent } from './boardlink/boardlink.component';
import { SaleComponent } from './sale/sale.component';
import { TrueFilterPipe } from './true-filter.pipe';
import { LocationSwitcherComponent } from './location-switcher/location-switcher.component';
import { MobileMenuButtonComponent } from './mobile-menu-button/mobile-menu-button.component';
import { UserComponent } from './user/user.component';
import { PrintTabComponent } from './print-tab/print-tab.component';
import { PrintMenuItemComponent } from './print-menu-item/print-menu-item.component';
import { PrintFullPageComponent } from './print-full-page/print-full-page.component';
import { PrintHalfPageComponent } from './print-half-page/print-half-page.component';
import { PrintSortPipe } from './print-sort.pipe';

const routes: Routes = [
  {path:"login", component:LoginComponent},
  {path:"control", component:ControlComponent, canActivate:[ControlCanActivate]},
  {path:"**", redirectTo:"/login"}
];

@NgModule({
  declarations: [
    AppComponent,
    ControlComponent,
    ProductFormComponent,
    MenuItemComponent,
    MenuComponent,
    ProductsComponent,
    ProductItemComponent,
    SettingsComponent,
    LoginComponent,
    MenuItemContainerComponent,
    ProductPipe,
    ProductSortPipe,
    LabelledProductsComponent,
    DetailsComponent,
    MenuSettingsComponent,
    AccountComponent,
    SupportComponent,
    LocationComponent,
    BoardlinkComponent,
    SaleComponent,
    TrueFilterPipe,
    LocationSwitcherComponent,
    MobileMenuButtonComponent,
    UserComponent,
    PrintTabComponent,
    PrintMenuItemComponent,
    PrintFullPageComponent,
    PrintHalfPageComponent,
    PrintSortPipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(routes),
    HttpModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    Ng2ImgToolsModule,
    AngularFireAuthModule
  ],
  exports:[RouterModule],
  providers: [Shared, ControlCanActivate, Ng2ImgToolsModule],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts